import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserPasswordChangeDtoModel } from '../user-password-change-dto.model';
import { NgForm } from '@angular/forms';
import { FormUtils } from "@irian-ro/util-forms";
import {
  MAXIMUM_PASSWORD_LENGTH,
  MEDIUM_PASSWORD_PATTERN,
  MINIMUM_PASSWORD_LENGTH,
  passwordRegex,
  STRONG_PASSWORD_PATTERN
} from '@irian-ro/constants';

@Component({
  selector: 'auth-user-change-password',
  templateUrl: './user-change-password.component.html',
  styleUrls: ['./user-change-password.component.scss'],
})
export class UserChangePasswordComponent {
  @Input() isUserAccountValid: boolean | undefined = undefined;
  @Output() submitChange: EventEmitter<UserPasswordChangeDtoModel> =
    new EventEmitter<UserPasswordChangeDtoModel>();

  passwordConfirmation: string | null = null;
  userPasswordChangeDtoModel: UserPasswordChangeDtoModel =
    new UserPasswordChangeDtoModel();

  private _userUuid: any = {};

  get userUuid(): any {
    return this._userUuid;
  }

  @Input() set userUuid(value: any) {
    if (value) {
      this._userUuid = value;
    }
  }

  private _isNewUser: boolean = null;

  get isNewUser(): boolean {
    return this._isNewUser;
  }

  @Input()
  set isNewUser(value: boolean) {
    this._isNewUser = value;
  }

  onSubmit(changePasswordForm: NgForm) {
    FormUtils.markAllAsDirty(changePasswordForm.form);
    FormUtils.markAllAsTouched(changePasswordForm.form);
    if (changePasswordForm.valid) {
      this.userPasswordChangeDtoModel.uuid = this.userUuid;
      this.submitChange.next(this.userPasswordChangeDtoModel);
    }
  }

  protected readonly minimumPasswordLength = MINIMUM_PASSWORD_LENGTH;
  protected readonly strongPasswordRegex = STRONG_PASSWORD_PATTERN;
  protected readonly passwordRegex = passwordRegex;
  protected readonly mediumPasswordRegex = MEDIUM_PASSWORD_PATTERN;
  protected readonly maximumPasswordLength = MAXIMUM_PASSWORD_LENGTH;
}
